import styled from 'styled-components';
import { AlertStyled } from '../AlertStyled';

export const AlertStyledAP = styled(AlertStyled)``;
